import React from 'react';
import './App.css';
import AdminDashboard from './AdminDashboard';
import UserActivity from './UserActivity';
import Support from './Support';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import LandingPage from './LandingPage';

const App: React.FC = () => {
  // Check URL path and parameters for routing
  const path = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const isAdminQueryRoute = urlParams.get('admin') === 'true';

  // Route: Admin Dashboard
  if (path === '/admin/dash' || path === '/admin' || path === '/admin-dashboard' || isAdminQueryRoute) {
    return <AdminDashboard />;
  }

  // Route: User Activity Page
  const userActivityMatch = path.match(/^\/admin\/users\/([^/]+)\/activity$/);
  if (userActivityMatch) {
    const userId = userActivityMatch[1];
    return <UserActivity userId={userId} />;
  }

  // Route 2: Support Page
  if (path === '/support') {
    return <Support />;
  }

  // Route 3: Privacy Policy
  if (path === '/privacy/policy' || path === '/privacy') {
    return <PrivacyPolicy />;
  }

  if (path === '/terms' || path === '/terms/of/service') {
    return <TermsOfService />;
  }

  // Landing page (default)
  return <LandingPage />;
};

export default App;
